export enum ContactSegment {
  // High potential
  HIGH_POTENTIAL_RETAILERS = 'high_potential_retailers',
  // Already ordered
  ALL_ORDERED_CONTACTS = 'all_ordered_contacts',
  // Eligible for 100€ voucher
  VOUCHER_ELIGIBLE_CONTACTS = 'voucher_eligible_contacts',
  // No order in last 6 months - 0% fee
  RETAILERS_TO_REACTIVATE = 'retailers_to_reactivate',
  // Did not order yet
  PROSPECTIVE_RETAILERS = 'prospective_retailers',
  // Did not order yet — 0% fee
  PROSPECTIVE_RETAILERS_NO_SERVICE_FEE = 'prospective_retailers_no_service_fee',
  // To be invited on Ankorstore
  NOT_SIGNED_UP_CONTACTS = 'not_signed_up_contacts',
  // Need restock
  NEED_RESTOCK = 'need_restock',
  // Disengaged or seasonal
  DISENGAGED_OR_SEASONAL = 'disengaged_or_seasonal',
  // Prospects
  PROSPECTS = 'prospects',
  // Abandoned cart
  ABANDONED_CART = 'abandoned_cart',
  CUSTOM = 'custom',
}
